export default {"src":"/_next/static/media/play-now.6e2c7507.svg","height":29,"width":29};